import { ModalParts } from 'BreetComponents';
import { useFiatWithdrawRequestContext, useUsdWithdrawRequestContext, useWithdrawRequestContext } from 'BreetHooks';

import { requestPaymentStageTitle, requestPaymentUsdStageTitle } from './DialogWithdrawRequest.helpers';
import FiatWithdrawRequest from './forms/fiat/FiatWithdrawRequest';
import UsdWithdrawRequest from './forms/usd/UsdWithdrawRequest';
import Header from './Header';

const Child = () => {
	const { selectedWallet } = useWithdrawRequestContext();

	const { formStage: fiatFormStage } = useFiatWithdrawRequestContext();
	const { formStage: usdFormStage } = useUsdWithdrawRequestContext();

	const isUsd = selectedWallet?.currency === 'USD';

	const formStage = isUsd ? usdFormStage : fiatFormStage;

	const root = isUsd ? requestPaymentUsdStageTitle['withdraw-funds'] : requestPaymentStageTitle['withdraw-funds'];

	return (
		<ModalParts.Wrapper
			title={formStage.stageTitle}
			root={root}
			handleBackLink={formStage.navigator.historyBack}
			rightSheet
		>
			<div className='payment-request-form withdraw-request-form'>
				<Header />

				{isUsd ? <UsdWithdrawRequest /> : <FiatWithdrawRequest />}
			</div>
		</ModalParts.Wrapper>
	);
};

export default Child;
